const instructionTypes = {
  ACHPPDPUSH: {
    description: 'ACH',
    fundTransferType: 'ACH',
    direction: 'outbound',
    ffcEmpty: true
  },
  ACHPPDPULL: {
    description: 'ACH',
    fundTransferType: 'ACH',
    direction: 'inbound',
    ffcEmpty: true
  },
  ACHCTXPUSH: {
    description: 'ACH',
    fundTransferType: 'ACH',
    direction: 'outbound',
    ffcPopulated: true
  },
  ACHCTXPULL: {
    description: 'ACH',
    fundTransferType: 'ACH',
    direction: 'inbound',
    ffcPopulated: true
  },
  MT101: {
    description: 'SWIFT MT101',
    fundTransferType: 'SWIFT',
    direction: 'outbound'
  },
  MT202: {
    description: 'SWIFT MT202',
    fundTransferType: 'SWIFT',
    direction: 'outbound'
  },
  MT103: {
    description: 'SWIFT MT103',
    fundTransferType: 'SWIFT',
    direction: 'outbound'
  }
} as const;

export type InstructionTypeCode = keyof typeof instructionTypes;

export const OUTBOUND_INSTRUCTION_TYPES = Object.entries(instructionTypes)
  .filter(([_, { direction }]) => direction === 'outbound')
  .map(([instructionTypeCode]) => instructionTypeCode as InstructionTypeCode);

export const INBOUND_INSTRUCTION_TYPES = Object.entries(instructionTypes)
  .filter(([_, { direction }]) => direction === 'inbound')
  .map(([instructionTypeCode]) => instructionTypeCode as InstructionTypeCode);

/**
 * Only show these instruction types if FFC is empty.
 */
export const FFC_EMPTY_INSTRUCTION_TYPES = Object.entries(instructionTypes)
  .filter(([_, details]) => (details as { ffcEmpty?: boolean }).ffcEmpty)
  .map(([instructionTypeCode]) => instructionTypeCode as InstructionTypeCode);

/**
 * Only show these instruction types if FFC is populated.
 */
export const FFC_POPULATED_INSTRUCTION_TYPES = Object.entries(instructionTypes)
  .filter(([_, details]) => (details as { ffcPopulated?: boolean }).ffcPopulated)
  .map(([instructionTypeCode]) => instructionTypeCode as InstructionTypeCode);

/**
 * Also known as "Settlement Method" in FIS.
 */
export type InstructionType = {
  readonly description: string;
  readonly fundTransferType: string;
  readonly instructionTypeCode: InstructionTypeCode;
};

export const availableInstructionTypes: InstructionType[] = Object.entries(instructionTypes).map(
  ([instructionTypeCode, details]) => ({
    description: details.description,
    fundTransferType: details.fundTransferType,
    instructionTypeCode: instructionTypeCode as InstructionTypeCode
  })
);

export const instructionTypeCodeToDescription = (instructionTypeCode: InstructionTypeCode) =>
  instructionTypes[instructionTypeCode].description;
